import React from 'react';
import PropTypes from 'prop-types';

export default function FilterIcon({ color }) {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1.94361 2.25C1.80777 2.25 1.69713 2.36221 1.69713 2.5V5.032C1.69713 5.10274 1.72749 5.17138 1.78033 5.21889L8.31502 10.4095C8.49399 10.5517 8.59854 10.7694 8.59854 11V17.286L10.9269 16.1052C11.0099 16.0632 11.0633 15.9769 11.0633 15.882V11.333C11.0633 11.1104 11.1608 10.8993 11.3294 10.7568L17.8759 5.22383C17.8759 5.22383 17.8759 5.22384 17.8759 5.22383C17.9325 5.17596 17.9647 5.10582 17.9647 5.032V2.5C17.9647 2.36221 17.8541 2.25 17.7183 2.25H1.94361ZM0.218262 2.5C0.218262 1.53379 0.991009 0.75 1.94361 0.75H17.7183C18.6709 0.75 19.4436 1.53379 19.4436 2.5V5.032C19.4436 5.55217 19.2156 6.04404 18.8226 6.37617L12.5422 11.6843V15.882C12.5422 16.545 12.173 17.151 11.5878 17.447C11.5877 17.4471 11.5879 17.447 11.5878 17.447L8.90261 18.8088C8.08417 19.2239 7.11967 18.6211 7.11967 17.691V11.3653L0.856718 6.39048C0.850825 6.3858 0.845002 6.38103 0.839252 6.37617C0.446012 6.04378 0.218262 5.55076 0.218262 5.032V2.5Z" fill={color}/>
    </svg>

  );
}

FilterIcon.propTypes = {
  color: PropTypes.string,
};

FilterIcon.defaultProps = {
  color: '#A39EB8'
};
